import $ from 'jquery';
import 'remodal';

import { selectButton, singleCheck } from '../../utils';

export default class {
  constructor($target) {
    this.$target = $target;
    this.bind();
  }

  bind() {
    const windowHeight = $(window).outerHeight()
    const height = $('header').outerHeight() + $('footer').outerHeight();

    $('#login').css('height', `${ windowHeight - height - 40}px` );
  }
}



// WEBPACK FOOTER //
// ./src/components/loginComponent/index.js